import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  AuthWrapper,
  MobileAuthWrapper,
  StyledUserButton
} from "./styles";
import { Link } from 'react-router-dom';
import { SignInButton, SignUpButton, UserButton, useUser } from "@clerk/clerk-react";
import styled from "styled-components";

const StyledSignInButton = styled(SignInButton)`
  background: transparent;
  color: #64748b;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 100px;
  font-weight: 500;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  letter-spacing: -0.01em;

  &:hover {
    color: #1e293b;
    background: #f1f5f9;
  }

  &:active {
    background: #e2e8f0;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const StyledSignUpButton = styled(SignUpButton)`
  background: #18181b;
  color: white;
  border: none;
  padding: 0.625rem 1.25rem;
  border-radius: 100px;
  font-weight: 500;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  letter-spacing: -0.01em;
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 100px;
    padding: 2px;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  &:hover {
    background: #000;
    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: scale(0.98);
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const Header = ({ t }: { t: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isSignedIn } = useUser();

  const showDrawer = () => {
    setIsOpen(!isOpen);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const MenuItem = () => {
    return (
      <>
        <CustomNavLinkSmall>
          <Link to="/dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Span>{t("Dashboard")}</Span>
          </Link>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <Link to="/roadmap" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Span>{t("Roadmap")}</Span>
          </Link>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <Link to="/find-coach" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Span>{t("Find Coach")}</Span>
          </Link>
        </CustomNavLinkSmall>
      </>
    );
  };

  const AuthButtons = () => (
    isSignedIn ? (
      <StyledUserButton>
        <UserButton afterSignOutUrl="/" />
      </StyledUserButton>
    ) : (
      <>
        <StyledSignInButton mode="modal" />
        <StyledSignUpButton mode="modal" />
      </>
    )
  );

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between" align="middle">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon
              src="logo.svg"
              aria-label="homepage"
              width="160px"
              height="89px"
            />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <AuthWrapper>
            <AuthButtons />
          </AuthWrapper>
          <Burger onClick={showDrawer}>
            <Outline />
          </Burger>
          <Drawer closable={false} open={isOpen} onClose={onClose}>
            <Col style={{ marginBottom: "2.5rem" }}>
              <Label onClick={onClose}>
                <Col span={12}>
                  <Menu>Menu</Menu>
                </Col>
                <Col span={12}>
                  <Outline />
                </Col>
              </Label>
            </Col>
            <MenuItem />
            <MobileAuthWrapper>
              <AuthButtons />
            </MobileAuthWrapper>
          </Drawer>
        </Row>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
